// import request from '@/utils/request'
import visitedRank from './mock/visitedRank.json'
export default {
   async getVisitedRank (params) {
     return {
        data: visitedRank
     }
   }
}
